import React from "react";
import Image from "../image";
import ContactImg from "../../assets/gifs/shape.gif";
import NationalImg from "../../assets/gifs/flag.gif";
import LocalSeoImg from "../../assets/gifs/arrow.gif";
import HeadlessImg from "../../assets/gifs/brain.gif";

const bgImg = {
  headlessimg: HeadlessImg,
  contactusimg: ContactImg,
  nationalseoimg: NationalImg,
  localseoimg: LocalSeoImg,
};

const About = ({
  desktopImg,
  mobileImg,
  titlel1,
  titlel2,
  caption,
  description,
  titleWidth,
}) => {
  return (
    <main tabindex="-1" role="main" id="main-content">
      <section class="hero -gold">
        <div
          class="hero-stack container"
          style={{
            backgroundImage: `url(${bgImg[desktopImg]})`,
          }}
        >
          <h1
            class="hero-headline -animatedLine"
            style={{ maxWidth: `${titleWidth}` }}
          >
            {titlel1} {titlel2}
            <br />
            <span>{caption}</span>
          </h1>
          <Image
            src={mobileImg}
            className="hero-innerImage-outer"
            imgClassName="hero-innerImage"
            placeholder="blurred"
          />
          <p
            class="hero-subheading"
            style={{ maxWidth: "40ch", marginBottom: "-5rem" }}
          >
            {description}
          </p>
        </div>
      </section>
    </main>
  );
};

export default About;
